import clock from '../../Assets/clock.png'
import clockn from '../../Assets/clock_inactive.png'
import { useState, useEffect, useRef } from 'react'
import diamondSound from '../../Assets/diamond.wav'
import FiveDTicket from '../../components/fiveDTicket'
import FiveDBalls from '../../components/FiveDBalls'
import FiveNew  from '../../components/FiveNew'
import Final from '../../components/FinalCountDown'
import vol from '../../Assets/vol.png'
import det from '../../Assets/det.png'
import balanceen2 from '../../Assets/balanceen2.svg'
import hist from '../../Assets/history.svg'
import edit from '../../Assets/edit.png'
import clear from '../../Assets/clear.svg'
import ResultBoard from '../../components/ResultBoard'
import fivedImg from '../../Assets/fivedImg.jpg'


const FiveD = ({ balance, setBalance }) => {
  const [isBetting, setIsBetting] = useState(false)
  const [grid, setGrid] = useState([]);
  const [revealed, setRevealed] = useState([]);
  const [gameOver, setGameOver] = useState(false);
  const [payoutMultiplier, setPayoutMultiplier] = useState(); // Initial multiplier
  const [cashedOut, setCashedOut] = useState(false)
  const [betAmount, setBetAmount] = useState(10)

  
  const playDiamondSound = () => {
    const audio = new Audio(diamondSound);
    audio.play();
  };
  let previousMultiplier = 1


  const [history, setHistory] = useState([]);
  const [cashOutAmount, setCashOutAmount] = useState(0)
  const [cashOutMultiplier, setCashOutMultiplier] = useState(1)


  const cashDisplay = payoutMultiplier * betAmount
  const scrollContainerRef = useRef(null);
  useEffect(()=>{
    if(scrollContainerRef.current){
      const scrollWidth = scrollContainerRef.current.scrollwidth
      const clientWidth = scrollContainerRef.current.clientWidth;
      scrollContainerRef.current.scrollTo({
        left:scrollWidth - clientWidth,
        scrollBehavior:'smooth'
      })
    }
  }, [])
  useEffect(() => {
    if(betAmount < 0.1) setBetAmount(0.1)

    if(betAmount > balance) setBetAmount(balance)
  }, [betAmount])
  const updateHistory=(value)=>{
    setHistory([...history, value])
  }
  const timers = [
    {
      name:'5D 30s',
      time:30,
    },{
      name:'5D 1min',
      time:60,
    },{
      name:'5D 3min',
      time:180,
    },{
      name:'5D 5min',
      time:300,
    },
  ]
  const [balls, setBalls] = useState([])
  const [colors, setColors] = useState([])

    function addBall(newBall){
      setShowControls(true)
      setBalls((prevBalls) => {
        // Check if the color already exists
        const ballExists = prevBalls.some((ball) => ball === newBall);
    
        if (ballExists) {
          console.log(`Color "${newBall}" already exists!`);
          return prevBalls; // Return the same array without changes
        }
    
        // Add the new color
        return [...prevBalls, newBall];
      });
    };
    function addColor(newColor){
      setShowControls(true)
      setColors((prevColors) => {
        // Check if the color already exists
        const colorExists = prevColors.some((color) => color.name === newColor.name);
    
        if (colorExists) {
          console.log(`Color "${newColor.name}" already exists!`);
          return prevColors; // Return the same array without changes
        }
    
        // Add the new color
        return [...prevColors, newColor];
      });
    };
  const [ activeTimer, setActiveTimer ] = useState(
    {
      name:'5D 30s',
      time:30
    })
    const reset =()=>{
      setColors([])
      setBalls([])
      console.log('cleared')
    }
    const [quantity,setQuantity] = useState(1)
    const [totalAmount,setTotalAmount] = useState(1)
    const [call,setCall] = useState(false)
    useEffect(()=>{
      setTotalAmount((quantity * betAmount) * (balls.length + colors.length))
    }, [quantity, balls, colors, betAmount])

    const [showControls,setShowControls] = useState(false)

    function close(){
      setShowControls(false)
      reset()
    }
    const positions = ['A','B','C','D','E', 'SUM']
    const [activepos, setActivepos] = useState('A')
    useEffect(()=>{
      reset()
    }, [activepos])
  return (
    <div className='select-none flex flex-col-reverse justify-center items-center '>
      <div className='controls w-[100vw] sm:w-[500px]'>

      
      <div  className="relative flex py-2 w-full h-auto px-[14px] pb-[20px] space-y-3 text-black flex-col bg-white rounded-tl-lg">
        {showControls && <img onClick={close} className='absolute cursor-pointer right-0 -top-[37px] w-[64px] h-[37px]' src={clear} alt='clear'/>}
        <div className='flex justify-between'>
          <div className='flex justify-center items-center space-x-2'>

          <p className='text-sm'>Balance: </p>
          <p className='font-bold'>28.00</p>
          <img style={{ width:'16px' }} src={balanceen2} alt='reload' />
          <p className='btn-bg px-2 text-white text-sm rounded-sm'>Deposit</p>
          </div>
          <div className='flex justify-center items-center space-x-1'>
          <p className='text-sm'>Bet History</p>
          <img style={{ width:'12px' }} src={hist} alt='history' />
          </div>
        </div>
        {call ? <Final/> : ''}
        {showControls &&
          <div className='flex flex-col'>
          <hr className='border-1  border-gray-300'/>
        <section className=" space-y-3">
        <div className='flex flex-col '>
        <div className="flex flex-wrap items-center w-full">
            <p className='text-sm  p-1'>Select:</p>
          <p className='text-2xl text-blue-600 px-2'>{activepos}</p>  
          <div className='flex flex-wrap'>
            {colors.map((color, index) =>(
              <div style={{ '--i':`${color.primary}`, '--e':`${color.sec}`, }} className='ml-2 cursor-pointer min-w-[40px] h-[23px] lottery_stakes flex justify-center items-center rounded-[2px] px-2 py-1'>
                <p className='text-white font-semibold capitalize text-sm'>
                  {color.name}
                </p>
              </div>  
            ))}
            {balls.map((ball, index) =>(
              <FiveNew i={ball}/>
              ))}
          </div>
        </div>
        </div> 
      <div className='flex flex-col justify-center  items-center'>
           
        <div className="flex justify-between w-full">
            <p className='text-sm  p-2'>Balance:</p>
            <div className='flex space-x-2 items-center rounded-lg py-2'>
                <button onClick={() => setBetAmount(1)} className={`${ betAmount === 1 ? 'text-white btn-bg' :'text-gray-700 border border-gray-400'}  rounded-full w-[48px] h-[32px]   text-[0.6rem] px-2 py-1`} >1
                </button>
                <button onClick={() => setBetAmount(10)} className={`${ betAmount === 10 ? 'text-white btn-bg' :'text-gray-700 border border-gray-400'}  rounded-full w-[48px] h-[32px]   text-[0.6rem] px-2 py-1`} >10
                </button>
                <button onClick={() => setBetAmount(100)} className={`${ betAmount === 100 ? 'text-white btn-bg' :'text-gray-700 border border-gray-400'}  rounded-full w-[48px] h-[32px]   text-[0.6rem] px-2 py-1`} >100
                </button>
                <button onClick={() => setBetAmount(1000)} className={`${ betAmount === 1000 ? 'text-white btn-bg' :'text-gray-700 border border-gray-400'}  rounded-full w-[48px] h-[32px]   text-[0.6rem] px-2 py-1`} >1000
                </button>
                <img style={{ width:'24px', height:'24px' }} src={edit} alt='edit' />
            </div>
        </div>
        <div className='flex w-full justify-between mt-1'>
        <p className='text-sm p-2 font-normal'>Quantity:</p>
        <div className='flex space-x-1 justify-center items-center'>
        <p onClick={()=> setQuantity(quantity > 1 ? quantity - 1 : 1)} className='flex justify-center items-center font-bold text-2xl p-1 btn-bg w-[30px] text-white text-center h-[30px] rounded-sm cursor-pointer'>-</p>
          <p style={{ width:'70px', height:'30px'}}  className='border border-gray-300 text-center rounded-sm font-semibold py-1' type='number'>{quantity}</p>
          <p onClick={()=> setQuantity(quantity + 1)} className='flex justify-center items-center font-bold text-2xl p-1 btn-bg w-[30px] text-white text-center h-[30px] rounded-sm cursor-pointer'>+</p>
        </div>
        </div>
        </div>

        <div className='flex w-auto justify-between space-x-2'>
        <button onClick={() => setQuantity(1)} className={`rounded-[5px] w-[35px] ${quantity === 1 ? 'btn-bg text-white' : 'text-gray-700 bg-gray-200'} text-[0.6rem] px-2 py-1`} >x1
        </button>
          <button onClick={() => setQuantity(5)} className={`rounded-[5px] w-[35px] ${quantity === 5 ? 'btn-bg text-white' : 'text-gray-700 bg-gray-200'} text-[0.6rem] px-2 py-2`} >x5
          </button>
          <button onClick={() => setQuantity(10)} className={`rounded-[5px] w-[35px] ${quantity === 10 ? 'btn-bg text-white' : 'text-gray-700 bg-gray-200'} text-[0.6rem] px-2 py-1`} >x10
        </button>
        <button onClick={() => setQuantity(20)} className={`rounded-[5px] w-[35px] ${quantity === 20 ? 'btn-bg text-white' : 'text-gray-700 bg-gray-200'} text-[0.6rem] px-2 py-1`} >x20
        </button>
        <button onClick={() => setQuantity(50)} className={`rounded-[5px] w-[35px] ${quantity === 50 ? 'btn-bg text-white' : 'text-gray-700 bg-gray-200'} text-[0.6rem] px-2 py-1`} >x50
        </button>
        <button onClick={() => setQuantity(100)} className={`rounded-[5px] w-[35px] ${quantity === 100 ? 'btn-bg text-white' : 'text-gray-700 bg-gray-200'} text-[0.6rem] px-2 py-1`} >x100
        </button>
        <button onClick={() => setQuantity(200)} className={`rounded-[5px] w-[35px] ${quantity === 200 ? 'btn-bg text-white' : 'text-gray-700 bg-gray-200'} text-[0.6rem] px-2 py-1`} >x200
        </button>
        </div>      

        <div className='flex space-x-2'>
        <button onClick={close} className="rounded-[5px] bg-gray-200 text-sm px-8 py-3" >Reset
        </button>
          <button  className="font-bold text-white w-full rounded-[5px] btn-bg text-sm px-10 py-3" >Total Amount ₹{totalAmount}
          </button>
        </div>
      </section>
      </div>
      }
      </div>
      </div>
      <div className='flex flex-col p-2'>
        {/* <Final/> */}
      </div>
      <div className=' rounded-lg flex flex-col w-full justify-center items-center '>
      <div class="scrolling-container m-3 my-2 flex justify-center items-center bg-white">
        <div className='p-2'>
          <img className='w-[20px]' src={vol} alt='vol'/>
        </div>
          <marquee behavior="scroll" direction="left" scrollamount="4">
              <p className='text-sm text-orange-600'>OFFICIAL Emirates Club WEBSITE LINK: emiratesclub.com please make sure, to always use this links to login , dont use other link to login to avoid any fraud, All recharge methods only available in RECHARGE menu on OFFICIAL TC website and application; 2.Submit 12 UTR number / UPI ref no for INSTANT recharge; 3. TC recharge account change everytime, DONOT SAVE to AVOID LOSS!!!</p>
          </marquee>
          <div className='bg-white p-2'>

          <div className='flex justify-center items-center cursor-pointer px-4 py-[0.15rem] bg-orange-500 rounded-full'>
              <img className='w-[12px] h-[12px]' src={det} alt='det'/>
              <p className='text-[0.8rem] text-white'>Detail</p>
        </div>
        </div>
      </div>
      <div className='grid grid-cols-4 rounded-lg w-full bg-white'>
        {timers.map((timer, index) => (
          <div onClick={(e) => setActiveTimer(timer)} key={index} style={{ '--i':`${timer.name === activeTimer.name ? 'orange' : ''}`, border:`${timer.name === activeTimer.name ? ' 1px solid orange' : '1px solid white'}` }} className={`cursor-pointer flex flex-col justify-center items-center rounded-lg lottery_time p-1 space-y-2`}>
          <img style={{ width:'44px', height:'44px' }} src={timer.name === activeTimer.name ? clock : clockn} alt='time'/>
          <p className={` ${timer.name === activeTimer.name ? 'text-orange-500' : 'text-gray-500'} text-[0.8rem] text-center`}>{timer.name}</p>
        </div>
        ))}
      </div>
      <FiveDTicket activeTimer={activeTimer} setCall={setCall} activeT={activeTimer}/>
      <img src={fivedImg} alt=''/>
      <div className='p-4 w-full bg-white rounded-lg mt-4'>
      <div className='flex gap-3 w-full bg-white'>
      {positions.map((pos, index) => (
      <button key={index} onClick={() => setActivepos(pos)} className={`${ activepos === pos ? 'text-white btn-bg' :'text-white bg-gray-400'}  rounded-t-full  ${pos === 'SUM' ? 'text-sm font-semibold px-1' : 'px-3 '} py-1`} >
        {pos}
      </button>))}
      </div>
      <div className='bg-white rounded-lg grid grid-cols-4 gap-2  w-full text-sm text-white  mt-2'>
      <div       className='cursor-pointer flex rounded-[5px] bg-gray-300 text-sm p-2 justify-between'>
            <p>Big</p>
            <p>1.9</p>
          </div>
          <div   className='cursor-pointer flex rounded-[5px] bg-gray-300 text-sm p-2 justify-between'>
            <p>Small</p>
            <p>1.9</p>
          </div>
          <div   className='cursor-pointer flex rounded-[5px] bg-gray-300 text-sm p-2 justify-between'>
            <p>Odd</p>
            <p>1.9</p>
          </div>
          <div   className='cursor-pointer flex rounded-[5px] bg-gray-300 text-sm p-2 justify-between'>
            <p>Even</p>
            <p>1.9</p>
          </div>
        </div>
      <FiveDBalls addStake={addBall}/>
          {/* <Balls addStake={addBall}/> */}
      </div>
      <ResultBoard/>  
      </div>
    </div>
  )
}

export default FiveD